import { push } from "connected-react-router";

import enums from "../enums";
import { getSessionTimeLimitAlertMessage, isProfileLimitTypeEnabled } from "./responsibleGamingErrors";
import { getUser, removeUser } from "./index";

export const SESSION_TIME_LIMIT_BLOCK_KEY = "rg_session_time_limit_blocked";

const normalizePath = (pathname = "") => pathname.split("?")[0].replace(/\/$/, "") || "/";

export const isSessionTimeLimitBlocked = () =>
	sessionStorage.getItem(SESSION_TIME_LIMIT_BLOCK_KEY) === "1";

export const setSessionTimeLimitBlocked = () => {
	sessionStorage.setItem(SESSION_TIME_LIMIT_BLOCK_KEY, "1");
};

export const clearSessionTimeLimitBlock = () => {
	sessionStorage.removeItem(SESSION_TIME_LIMIT_BLOCK_KEY);
};

export const isLimitsManagementRoute = (pathname) =>
	Array.isArray(window.PROFILE_LIMITS_MODULE) &&
	window.PROFILE_LIMITS_MODULE.length > 0 &&
	normalizePath(pathname) === "/profile/limits";

export const isPlayRoute = (pathname = "") => {
	const path = normalizePath(pathname);

	return (
		path.startsWith("/casino") ||
		path === "/casino-favorites" ||
		path.startsWith("/sportsbook") ||
		path === "/tv-games"
	);
};

export const shouldEnforceSessionTimeLimit = () =>
	isProfileLimitTypeEnabled("sessionTime") &&
	isSessionTimeLimitBlocked() &&
	Boolean(getUser());

export const dispatchSessionTimeLimitAlert = (dispatch) => {
	dispatch({
		type: enums.ALERT_IN,
		payload: {
			type: "error",
			...getSessionTimeLimitAlertMessage(),
		},
	});
};

export const handleSessionTimeLimitExceeded = (dispatch, options = {}) => {
	if (!isProfileLimitTypeEnabled("sessionTime")) {
		return;
	}

	const { forceNotify = false } = options;
	const pathname = window.location.pathname;
	const wasLoggedIn = Boolean(getUser());
	const alreadyBlocked = isSessionTimeLimitBlocked();
	const onLimitsPage = isLimitsManagementRoute(pathname);
	const onPlayRoute = isPlayRoute(pathname);

	if (!alreadyBlocked) {
		setSessionTimeLimitBlocked();
	}

	if (!onLimitsPage && wasLoggedIn) {
		removeUser();
		window.dispatchEvent(new CustomEvent("userLogout"));
		dispatch({ type: enums.LOGOUT_SUCCESS, payload: false });
	}

	if (forceNotify || (wasLoggedIn && !alreadyBlocked)) {
		dispatchSessionTimeLimitAlert(dispatch);
	}

	if (onPlayRoute && wasLoggedIn) {
		dispatch(push("/"));
	}
};

export const guardPlayRouteAccess = (dispatch, pathname = window.location.pathname) => {
	if (!isProfileLimitTypeEnabled("sessionTime") || !isPlayRoute(pathname) || !shouldEnforceSessionTimeLimit()) {
		return false;
	}

	dispatchSessionTimeLimitAlert(dispatch);
	dispatch(push("/"));

	return true;
};
